import { getJson, postJson } from 'api_helpers.js'
import _ from "lodash";
import { actions as formActions } from 'react-redux-form'
import history from "../custom_history";
import { entityRoute } from "../route_helpers";
import { createContactWithDefaults } from "./contacts";
import { fetchEntities } from "./entities";
import { fetchEntitiesFailure } from "./entities";
import { fetchEntity } from "./entities";
import { deleteEntity } from "./entities";
import { requestEntities } from "./entities";
import { createEntityWithDefaults } from "./entities";

export const REQUEST_DOSSIERS = 'REQUEST_DOSSIERS'; export function requestDossiers() {
  return {
    type: REQUEST_DOSSIERS
  };
}

export const RECEIVE_DOSSIERS = 'RECEIVE_DOSSIERS';
export function receiveDossiers(dossiers) {
  return {
    type: RECEIVE_DOSSIERS,
    dossiers: dossiers
  };
}

export const FETCH_DOSSIERS_FAILURE = 'FETCH_DOSSIERS_FAILURE';
export function fetchDossiersFailure(error) {
  return {
    type: FETCH_DOSSIERS_FAILURE,
    error: error
  };
}

export const FETCH_DOSSIERS= 'FETCH_DOSSIERS';
export function fetchDossiers() {
  return function(dispatch) {

    dispatch(requestDossiers())

    return getJson(Routes.api_dossiers_path()).then (
      response => response.json(),
      error => dispatch(fetchDossiersFailure(error))
    ).then (
      json => {
        dispatch(receiveDossiers(json.data));
        dispatch(formActions.setPristine("dossiers"))
      }
    )
  }
}

export const CREATE_DOSSIER_FAILURE = 'CREATE_DOSSIER_FAILURE';
export function createDossierFailure(dossier) {
  return {
    type: CREATE_DOSSIER_FAILURE,
    dossier: dossier
  };
}

export const CREATE_DOSSIERS = 'CREATE_DOSSIERS';
export function createDossiers(dossiers) {
  return function(dispatch) {

    return postJson(Routes.bulk_create_api_dossiers_path(), {dossiers: dossiers}).then (
      response => response.json(),
      error => dispatch(createDossiersFailure(error))
    ).then (
      json => dispatch(fetchDossiers())
    )
  }
}

export const CREATE_DOSSIER = 'CREATE_DOSSIER';
export function createDossier(dossier) {
  return function(dispatch) {
    dispatch(createDossiers([dossier]))
  }
}
export function createDossierWithDefaults(entity = {}) {
  return function(dispatch, getState) {
    let contactId = dispatch(createContactWithDefaults())
    return dispatch(createEntityWithDefaults('dossier', _.merge({}, { patientId: contactId }, entity), false))
  }
}

export const UPDATE_DOSSIERS = 'UPDATE_DOSSIERS';
export function updateDossiers(dossiers) {
  return function(dispatch) {

    return postJson(Routes.bulk_update_api_dossiers_path(), {dossiers: dossiers}).then (
      response => response.json(),
      error => dispatch(updateDossiersFailure(error))
    ).then (
      json => dispatch(fetchDossiers())
    )
  }
}

export const UPDATE_DOSSIER = 'UPDATE_DOSSIER';
export function updateDossier(dossier) {
  return function(dispatch) {
    dispatch(updateDossiers([dossier]))
  }
}

export function mergeDossiers(mainDossierId, otherId) {
  return function(dispatch) {
    dispatch(requestEntities('dossiers'))
    return postJson(Routes.merge_dossiers_api_dossier_path({ id: mainDossierId, other_dossier_id: otherId, _options: true })).then (
      response => response.json(),
      error => dispatch(fetchEntitiesFailure('dossiers'))
    ).then (
      json => {
        if(json.errors) {
          const err = json.errors[0] || {}
          if (err.status === "403" || err.status === "401" ) {
            dispatch({type: 'UPDATE_UI_STATE' , payload: { key: 'mainModal', name: 'isMainModalVisible', value: true  }} )
          }
        } else {
          history.push(entityRoute('dossier', false, { id: mainDossierId }))
          dispatch(deleteEntity('dossier', otherId, false))
          dispatch(fetchEntities('consultations', {name: 'dossier', filter: {dossierId: mainDossierId}, page: 1}))
          dispatch(fetchEntities('dossierItems', { name: 'dossier', filter: {dossierId: mainDossierId}, page: 1}))
          dispatch(fetchEntities('invoices', { name: `dossier`, filter: { dossierId: mainDossierId }, page: 1 }))
          dispatch(fetchEntities('documents', { name: `dossier`, filter: { dossierId: mainDossierId }, page: 1 }))
          return dispatch(fetchEntity('dossiers', mainDossierId))
        }
      }
    )
  }
}
export const NEW_DOSSIER = 'NEW_DOSSIER'
export function newDossier() {
  return {
    type: NEW_DOSSIER
  };
}
